import React from 'react'
import '../styles/Footer.styles.css'
import { MdOutlineEmail,MdOutlineWhatsapp} from "react-icons/md";
import { FaFacebookF, FaInstagram, FaTiktok } from "react-icons/fa";

export default function Footer() {
  const goSection = (section) => {
    const targetElement = document.getElementById(section);
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }
  return (
    <footer className='footer' id='contacto'>
      <div className="ft-container">
        <div className="ft-containerBody">
          <div className="ft-head">
            <div onClick={()=>goSection('inicio')}>INICIO</div>
            <div onClick={()=>goSection('nosotros')}>NOSOTROS</div>
            <div onClick={()=>goSection('constructora')}>CONSTRUCTORA</div>
            <div onClick={()=>goSection('desarrolladora')}>DESARROLLADORA</div>
            <div onClick={()=>goSection('inmobiliaria')}>INMOBILIARIA</div>
          </div>
          <div className="ft-body">
            <div className="ft-socialMedia">
              <div>
                <a href='mailto:inmobiliariacrosmo@gmail.com' target="_blank" rel="noreferrer">
                  <MdOutlineEmail color='white'/>
                </a>
              </div>
              <div>
                 <a href='https://wa.me/527471943052' target="_blank" rel="noreferrer">
                  <MdOutlineWhatsapp color='white'/>
                </a>
              </div>
              <div>
                <a href='https://www.facebook.com/RosmoConstrucciones' target="_blank" rel="noreferrer">
                  <FaFacebookF color='white'/>
                </a>
              </div>
              <div>
                <a href='https://www.instagram.com/rosmoconstrucciones/' target="_blank" rel="noreferrer">
                  <FaInstagram color='white'/>
                </a>
              </div>
              <div>
                <a href='https://www.tiktok.com/@rosmoconstrucciones' target="_blank" rel="noreferrer">
                  <FaTiktok color='white'/>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="ft-containerFooter">
          <label>
            {
              '©2026 ROSMOCOIN. Todos los Derechos Reservados. Creado Por '
            }
            <a href="https://github.com/greciaDenisse" target="_blank" rel="noopener noreferrer">Grecia</a>
            {
              ' & '
            }
            <a href="https://github.com/Santiago-MF" target="_blank" rel="noopener noreferrer">SantiDev</a>.
          </label>
        </div>
      </div>
    </footer>
  )
}
